import useCurrentState from "../hooks/use-current-state";

export default useCurrentState;
